import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const DEFAULT_REVIEW_URL = "https://g.page/r/CTs1HaVy-ImXEAE/review";

export function useGoogleReviews() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/reviews/google").then((r) => setData(r.data)).catch(() => setData({ reviews: [] }));
  }, []);
  return data;
}
